var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDailyPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 21.8755L2.5 22.3755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 26.1255L2.5 38.1255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 13.6255L9.375 14.1255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 17.8755L9.375 46.3755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 17.6255L16.25 38.1255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 41.8755L16.25 42.3755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M23.125 25.5005L23.125 34.5005",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M30 17.3755L30 17.8755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M30 21.6255L30 42.6255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M36.875 24.3755L36.875 31.3755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M36.875 35.1255L36.875 35.6255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M43.75 19.6255L43.75 20.1255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M43.75 23.8755L43.75 40.3755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M50.625 11.5005L50.625 12.0005",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M50.625 15.7505L50.625 48.5005",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5 37.3755L57.5 36.8755",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M57.5 33.1255L57.5 22.6255",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round"
})));
export default SvgIconDailyPlus;